export const FOLLOWERS_ON_PROJECT_EXPERIMENT = 'followers-visible-on-project';

export const ATLAS_JIRA_GET_ATLAS_FREE = 'atlas_jira_get_atlas_free';
export const ATLAS_JIRA_SEARCH_JIRA_ISSSUES = 'atlas_jira_search_jira_issues';
export const ROVO_SEARCH_COMPARE_RESULTS_PASS_THROUGH_RATE = 'rovo-search-compare-results-pass-through-rate';
export const NAVX_UNIVERSAL_CREATE_EXPERIMENT = 'navx_universal_create_experiment_nav4';

// https://switcheroo.atlassian.com/ui/gates/1705872e-b4eb-4f1d-9c1f-9ac0aca67f3d
export const ENABLE_CREATE_PROJECT_MENU_VISUAL_REFRESH = 'enable_create_project_menu_visual_refresh';

// Nav refresh 'beta' experiments
// https://hello.atlassian.net/wiki/spaces/JNR/pages/3699574590/Rollout+technical+design#Beta
export const NAV_REFRESH_FREE_CUSTOMERS_EXP = 'jira_nav4_beta_free-customers';
export const NAV_REFRESH_NEW_CUSTOMERS_EXP = 'jira_nav4_beta_new-customers';
export const NAV_REFRESH_NEW_CUSTOMERS_X_EXP = 'confluence_jira_nav4_new_customers';

// https://switcheroo.atlassian.com/ui/gates/f1522991-2cd0-4325-9ff7-bb7478251069/key/townsquare_enable_workfeeds_experiment
export const WORK_FEEDS_EXPERIMENT = 'townsquare_enable_workfeeds_experiment';

// https://hello.atlassian.net/wiki/spaces/~7012112fe3ad051b544a8a2b95a2364de0021/pages/5137502682/Statsig+Targetting+for+TenantId
export const ROVO_TEAM25_ROLLOUT_PERFORMANCE_EXP = 'rovo_team25_rollout_performance_exp';
export const ROVO_TEAM25_ROLLOUT_PERF_B3A_EXP = 'rovo_team25_rollout_perf_b3a_exp';

// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/townsquare_home_header_experiment/setup
export const HOME_HEADER_EXPERIMENT = 'townsquare_home_header_experiment';

// https://switcheroo.atlassian.com/ui/gates/d833f6e5-0701-4c1a-aeaf-dd5c42e0faef/key/teams_as_a_standalone_app
export const TEAMS_AS_A_STANDALONE_APP = 'teams_as_a_standalone_app';

// Make sure you add your experiment to the list of valid experiments
export const experiments = {
  ATLAS_JIRA_GET_ATLAS_FREE,
  ATLAS_JIRA_SEARCH_JIRA_ISSSUES,
  ENABLE_CREATE_PROJECT_MENU_VISUAL_REFRESH,
  FOLLOWERS_ON_PROJECT_EXPERIMENT,
  ROVO_SEARCH_COMPARE_RESULTS_PASS_THROUGH_RATE,
  NAV_REFRESH_FREE_CUSTOMERS_EXP,
  NAV_REFRESH_NEW_CUSTOMERS_EXP,
  NAV_REFRESH_NEW_CUSTOMERS_X_EXP,
  NAVX_UNIVERSAL_CREATE_EXPERIMENT,
  WORK_FEEDS_EXPERIMENT,
  ROVO_TEAM25_ROLLOUT_PERFORMANCE_EXP,
  ROVO_TEAM25_ROLLOUT_PERF_B3A_EXP,
  HOME_HEADER_EXPERIMENT,
  TEAMS_AS_A_STANDALONE_APP,
} as const;

export type ExperimentKeys = keyof typeof experiments;
export type ExperimentNames = (typeof experiments)[ExperimentKeys];
